/** FR keyword tree → EN counterpart. null means explicitly untranslated; absent means unknown.
 * Maintain alongside keyword-tree changes; see README.md in this package.
 */
export const keywordTreeTranslations: Readonly<Partial<Record<string, string | null>>> = {
    'baux-commerciaux': 'commercial-leases-in-french-law',
    consommation: 'french-consumer-law',
    'contrats-d-affaires': 'business-contracts-in-french-law',
    'droit-de-la-conformite': 'compliance',
    'droit-des-societes': 'french-company-law',
    'droit-europeen-de-la-concurrence': 'european-competition-law',
    'droit-europeen-de-la-distribution': 'european-distribution-law',
    'droit-europeen-des-affaires': 'european-business-law',
    'droit-francais-de-la-concurrence': 'french-competition-law',
    'droit-francais-de-la-distribution': 'french-distribution-law',
    'droit-penal-des-affaires': 'white-collar-crime',
    'droit-processuel-1': 'procedural-law-1',
    'droit-processuel-2': 'procedural-law-2',
    'droit-processuel-3': 'procedural-law-3',
    'droit-processuel-4': 'procedural-law-4',
    'droit-processuel-5': 'procedural-law-5',
    'droit-processuel-6': 'procedural-law-6',
    'droit-processuel-7': 'procedural-law-7',
    'numerique-ia': null,
    'procedures-collectives': 'insolvency-proceedings-in-french-law',
    'propriete-intellectuelle': 'french-intellectual-property-law',
};
